module.exports = __webpack_public_path__ + "static/img/mcewen-jermaine.cd4eb65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mcewen-jermaine.jpg
// module id = LA3l
// module chunks = 0